import { CopyBlock, dracula } from "react-code-blocks"
import Button from "react-bootstrap/Button"

const varsSnippet = `
  playerBullets;
  fireRate = 200;
  nextFireTime = 0;
`

const assetSnippet = `
    this.load.image("bullet", "projectile.png");
`
const bulletSnippet = `
    this.playerBullets = this.physics.add.group();
    this.playerBullets.createMultiple({
      key: "bullet",
      quantity: 20,
      active: false,
      visible: false
    });
`

const fireSnippet = `
  fire(dt) {
    this.nextFireTime -= dt;
    if (this.nextFireTime > 0) {
      return;
    }
    const bullet = this.playerBullets.getFirstDead();
    if (bullet === undefined || bullet == null) {
      return;
    }

    bullet.enableBody(true, this.player.x + 50, this.player.y, true, true);
    bullet.setScale(0.3);
    bullet.body.velocity.x += 300;
    setTimeout(() => bullet.disableBody(true, true), 2000);
    this.nextFireTime = this.fireRate;
  }
`

const spaceInputSnippet = `
    if (this.cursors.space.isDown) {
      this.fire(dt);
    }
`

const PlayerInput = () => (
  <>
    <h1>Player Projectiles</h1>
    <p>
      Now that we can move the plane around, it would be more interesting if we
      could shoot some bullets. Lets add some new variable for bullets.
    </p>

    <CopyBlock
      text={varsSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now inside the preload function when need to tell phaser what the bullet
      image is named. Use the code snippet below:
    </p>
    <CopyBlock
      text={assetSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      Now that we have our image loaded we have to tell Phaser what bullets are,
      add the following into the create method:
    </p>
    <CopyBlock
      text={bulletSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      What we are telling Phaser is we want to have more than one bullet, so we
      create a group of them. You might think I want hundreds of bullets which
      we could do, but this is expensive in memory. We can just hide and show
      bullets based on how they interact with the environment and give the
      appearance of hundreds of bullets.
    </p>
    <p>
      Now that we have some bullets we need to tell phaser how and when to show
      them. Which would include the player pushing the space bar, create the
      bullets next the airplane, move the bullets accross the screen, and
      removing them after some time.
    </p>
    <p>
      We will start by adding a new function. Add the following below the update
      method:
    </p>
    <CopyBlock
      text={fireSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />

    <p>
      The last thing we need to do is capture the input of the keyboard and then
      call the fire function. Just below the check player input add this code
      snippet:
    </p>
    <CopyBlock
      text={spaceInputSnippet}
      language={"js"}
      showLineNumbers={true}
      theme={dracula}
      codeBlock
    />
    <p>
      If you were successful in adding this code the plane should now fire
      bullets.
    </p>
    <Button type="button" variant="secondary" href="/Enemies">
      Next
    </Button>
    <br />
    <br />
  </>
)

export default PlayerInput
